"use client";

import type { CommunityBroadcast } from "@packages/sdk";
import { createModal, useModal } from "@packages/ui";
import { useCallback } from "react";

import { BroadcastCreateModal } from "../../../app/[locale]/admin/[communityId]/broadcast/BroadcastCreateModal";

export type BroadcastEditModalProps = {
  broadcast: CommunityBroadcast;
  communityId: number;
};

/**
 * "Edit" on a scheduled broadcast, per Scenario 5a.
 *
 * The compose modal itself, opened on an existing broadcast: `PUT` replaces
 * content, recipients and schedule outright, which is what that form already
 * produces, and the design uses one modal for both. This only supplies the
 * open state, since the options menu opens it from inside the list rather than
 * from a trigger of its own.
 */
export const BroadcastEditModal = createModal<BroadcastEditModalProps>(
  ({ broadcast, communityId }: BroadcastEditModalProps) => {
    const editModal = useModal(BroadcastEditModal);

    /**
     * Idempotent on purpose: the compose modal closes by toggling, and its
     * submit path toggles twice.
     */
    const handleClose = useCallback(() => editModal.remove(), [editModal]);

    return (
      <BroadcastCreateModal
        broadcast={broadcast}
        communityId={communityId}
        handleToggleOpen={handleClose}
        open={editModal.visible}
        setOpen={handleClose}
      />
    );
  },
);
